import { useCart } from "../contexts/CartContext.tsx";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext.tsx";
import { useEffect, useState } from "react";
import api from "../services/api.tsx";
import { useError } from "../contexts/ErrorContext.tsx";
import { getDiscountedPrice } from "../utils/price.tsx";

const CartPage = () => {
  const { cart, removeFromCart, total } = useCart();
  const { isAuthenticated } = useAuth();
  const [campaigns, setCampaigns] = useState<{ [id: string]: { name: string; discountRate: number } }>({});
  const { setError } = useError();

  // Fetch campaign info for items in the cart
  useEffect(() => {
    const fetchCampaigns = async () => {
      const campaignIds = cart
        .filter(item => item.campaignId)
        .map(item => item.campaignId);
      if (campaignIds.length > 0) {
        try {
          const res = await api.get("/api/campaign", { params: { ids: campaignIds } });
          // Assume backend returns an array of campaigns
          const campaignMap: { [id: string]: { name: string; discountRate: number } } = {};
          res.data.forEach((c: any) => {
            campaignMap[c.id] = { name: c.name, discountRate: c.discountRate };
          });
          setCampaigns(campaignMap);
        } catch (error) {
          setCampaigns({});
          setError(error.response?.data?.Message || "Bir hata oluştu.");
        }
      }
    };
    fetchCampaigns();
  }, [cart, setError]);

  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-center">Sepet</h2>
      {cart.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-64">
          <p className="text-lg text-gray-500">Sepetiniz boş.</p>
          <Link to="/" className="mt-4 text-blue-600 underline">Alışverişe Başla</Link>
        </div>
      ) : (
        <div className="space-y-4">
          <div className="flex flex-col gap-4">
            {cart.map((item) => {
              const campaign = item.campaignId ? campaigns[item.campaignId] : null;
              return (
                <div
                  key={item.productId}
                  className="flex flex-col sm:flex-row justify-between items-center border rounded-lg shadow-sm bg-white p-4 gap-4"
                >
                  <div className="flex-1 w-full flex flex-col sm:flex-row sm:items-center gap-2">
                    <div className="flex-1">
                      <p className="font-semibold text-lg">{item.name}</p>
                      {campaign ? (
                        <>
                          <p className="text-sm text-green-700">
                            Kampanya: {campaign.name} (%{campaign.discountRate} indirim)
                          </p>
                          <p>
                            <span className="text-gray-600 line-through">{item.price} TL</span>{" "}
                            <span className="font-bold text-blue-700">
                              {(getDiscountedPrice(item.price, campaign.discountRate)).toLocaleString()} TL x {item.quantity}
                            </span>
                          </p>
                        </>
                      ) : (
                        <p className="text-blue-700 font-bold">{item.quantity} x {item.price.toLocaleString()} TL</p>
                      )}
                    </div>
                  </div>
                  <button
                    className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                    onClick={() => removeFromCart(item.productId)}
                  >
                    Kaldır
                  </button>
                </div>
              );
            })}
          </div>
          <div className="sticky bottom-0 bg-white py-4 px-2 rounded shadow flex flex-col sm:flex-row justify-between items-center mt-6">
            <div className="font-bold text-xl text-gray-800">
              Toplam: <span className="text-green-700">{total.toLocaleString()} TL</span>
            </div>
            <div className="mt-3 sm:mt-0">
              <Link to="/checkout">
                <button className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition font-semibold text-lg">
                  Sepeti Onayla
                </button>
              </Link>
            </div>
          </div>
          {cart.some(item => item.campaignId) && !isAuthenticated && (
            <p className="text-red-600 mt-2 text-center">
              Kampanyalı ürünler için ödeme yapabilmek için giriş yapmalısınız.
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default CartPage;